import React, { FC } from 'react';
import styled from '@emotion/native';
import {
  Container as ContainerBase,
  Right as RightBase,
  Content as ContentBase,
  TextInput as TextInputBase,
  Text as TextBase,
  Props as InputProps
} from '@components/2-molecules/Input';
import * as utils from '@lib/utils';
import { useTheme } from '@emotion/react';


const Wrapper = styled.View``;


/* max-height: ${({ multiline }: any) => (multiline && `100px`) || `auto`};
flex-direction: row; */
const Container = styled(ContainerBase)`
  border-radius: 0px;
  border-width: 0px;
  min-height: 39px;
  justify-content: center;
`;

/* width: auto; */
const Right = styled(RightBase)`
  // margin-top: -9px;
`;

const Left = styled(Right)``;

const Content = styled(ContentBase)`
  justify-content: center;
`;

const Text = styled(TextBase)``;

const TextView: FC<Props> = ({ onPress, defaultValue = '', label, required, accent, left, right, size = 14, height, style, date, ...props }) => {

  const theme = useTheme();
  // @ts-ignore
  height = height || Math.max(Math.floor((size * defaultValue?.length / 2) / theme.contentWidth) * 39, 90);
  
  date && (defaultValue = utils.formatDate(defaultValue, "LLL dd, yy"));

  return (
    <Wrapper>
      {label?.length ? <Text small>{label} {required && <Text small color="#F00"> *</Text>} </Text> : null}

      <Container onPress={onPress} style={style} {...props}>
        {left ? <Left>{left}</Left> : null}

        <Content>
          <Text small children={defaultValue} {...props} />
        </Content>

        {right ? <Right>{right}</Right> : null}
      </Container>
    </Wrapper>
  );
}


export type Props = InputProps & {
  onPress?: () => void;

  height?: number;
  left?: any;
  right?: any;
  date?: boolean;
  mini?: boolean;
  label?: string;
  required?: boolean;
  style?: object;
  accent?: string;
  multiline?: boolean;
};

export default TextView;